import {
  Button,
  Drawer,
  Form,
  Input,
  message,
  Radio,
  Space,
  Switch,
} from 'antd';
import { saveNotice } from '@/api/voteActivity';
import { useEffect } from 'react';
import { LINKTypeMap, LINKTypeEnum } from './type';

const NoticeDrawer = ({ name, data, onSuccess, onClose }) => {
  const [form] = Form.useForm();

  const linkType = Form.useWatch('linkType', form);

  const onSubmit = async () => {
    const values = await form.validateFields();
    console.log(values)

    const params = {
      ...values,
      publishStatus: Number(values.publishStatus)
    }
    if (data) {
      params.id = data.id;
    }

    const res = await saveNotice(params);

    const resdata = res.data;
    if (res.status === 200 && resdata?.status === 200) {
      message.success('保存成功');
      onSuccess?.();
      return;
    }

    message.error(resdata?.message);
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    } else {
      form.setFieldsValue({
        publishStatus: 0,
      });
    }
  }, [data]);

  return (
    <Drawer
      title={`${data ? '编辑' : '创建'}${name}`}
      open={true}
      onClose={onClose}
      width={600}
      maskClosable={false}
      extra={
        <Space>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={onSubmit}>
            确定
          </Button>
        </Space>
      }
    >
      <Form form={form}>
        <Form.Item label="公告内容" name="content" rules={[{ required: true }]}>
          <Input.TextArea
            placeholder="请输入公告内容描述……"
            style={{ height: 188 }}
          />
        </Form.Item>
        <Form.Item
          label="跳转链接"
          name="linkType"
          rules={[{ required: true }]}
        >
          <Radio.Group>
            {[...LINKTypeMap.values()].map((item, index) => {
              return (
                <Radio value={index} key={index}>
                  {item}
                </Radio>
              );
            })}
          </Radio.Group>
        </Form.Item>
        {[LINKTypeEnum.CONTESTID, LINKTypeEnum.LINK].includes(linkType) && (
          <Form.Item
            name="link"
            rules={[{ required: true, message: `请输入` }]}
          >
            <Input placeholder="请输入……" />
          </Form.Item>
        )}
        <Form.Item
          label="是否发布"
          name="publishStatus"
          rules={[{ required: true }]}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Drawer>
  )
}

export default NoticeDrawer;